import clsx from 'clsx';
import React from 'react';

import { PrimaryButton } from '@components/Button/variants';
import Benefits from '@components/pages/SubscriptionLanding/Benefits';
import useEventTracking from '@hooks/useEventTracking';
import { click } from '@tracking';
import { titleType } from '@utils/subscriptionCardOptions';

interface SubscriptionOptionCardProps {
  benefits: string[];
  buttonText?: string;
  disableButton?: boolean;
  href?: string;
  length: string;
  originalPrice?: number;
  price: number;
  title: titleType;
}

const SubscriptionOptionCard = ({
  benefits,
  buttonText = 'Subscribe',
  disableButton = false,
  href,
  length,
  price,
  title,
}: SubscriptionOptionCardProps) => {
  const { trackEvent } = useEventTracking();

  return (
    <aside className="bg-white md:px-16 md:py-32">
      <h4 className="m-0 text-center font-suisse-works text-headline-xxs text-black md:h-64 lg:h-auto">
        {title}
      </h4>
      <div className="mb-16 flex items-center justify-center font-suisse-intl text-body-lg text-grayscale-gray">
        <span>
          ${price}
          &nbsp;
        </span>
        <span>/ {length}</span>
      </div>
      <PrimaryButton
        as="link"
        size="small"
        href={href}
        className={clsx('w-full lg:max-w-[270px]', {
          'pointer-events-none': disableButton,
        })}
        onClickCapture={() => trackEvent(click({ clickTarget: buttonText }))}
      >
        {buttonText}
      </PrimaryButton>
      <Benefits benefits={benefits} />
    </aside>
  );
};

export default SubscriptionOptionCard;
